































































































































































import Vue from 'vue';
import moment from 'moment';
import { mapGetters } from 'vuex';

import { iconsMixin } from '@/mixins/icons';
import { breakpointsMixin } from '@/mixins/breakpoints';
import { authMixin } from '@/mixins/auth';
import { formatMixin } from '@/mixins/format';

import EdiLinkLookup from '@/models/edi/EdiLinkLookup';

import ediService from '@/services/EdiService';
import miscService from '@/services/MiscService';
import localStorageService from '@/services/LocalStorageService';

export default Vue.extend<any, any, any, any>({
  mixins: [iconsMixin, breakpointsMixin, authMixin, formatMixin],
  data() {
    return {
      currentPage: 1,
      pageSize: 25,
      loading: false,
      displayReadonlyDisclaimer: true,
      showCodesinfoPopup: false,
      deleting: false,
      snackbar: false,
      snackbarText: null,
      term: '',
      displayConfirmDelete: false,
      currentEdi: null,
    };
  },
  created() {
    this.fetch();
  },
  methods: {
    onClear() {
      this.term = '';
      this.applyFilters();
    },
    softDeleteEdiBatch() {
      this.deleting = true;
      ediService
        .deleteEdiLinkBatch({
          accountId: this.currentEdi.clientId,
          carrierId: this.currentEdi.carrierIdMap,
          senderId: this.currentEdi.senderId,
          receiverId: this.currentEdi.receiverId,
          ediIds: this.currentEdi.ediIds,
          codes: this.currentEdi.codes,
        })
        .finally(() => {
          this.deleting = false;

          this.snackbar = true;
          this.snackbarText = 'EDI batch deleted successfully';

          miscService.reloadPage();
        });
    },
    fetch() {
      this.loading = true;
      ediService.getAllEdiLinks().then((x: EdiLinkLookup[]) => {
        this.$store.commit('ediLinks/setEdiLinks', x);

        this.applyFilters();
        this.loading = false;
      });
    },
    applyFilters() {
      let items = this.all;

      if (this.term) {
        items = items
          .filter((x) => x)
          .filter(
            (x) =>
              x.clientName?.toLowerCase().includes(this.term.toLowerCase()) ||
              x.carrierName?.toLowerCase().includes(this.term.toLowerCase()) ||
              x.senderId?.toLowerCase().includes(this.term.toLowerCase()) ||
              x.receiverId
                ?.toString()
                .toLowerCase()
                .includes(this.term.toLowerCase())
          );
      }

      this.$store.commit('ediLinks/setFilteredEdiLinks', items);
      this.$store.commit('ediLinks/setPage', items.slice(0, this.pageSize));
      this.currentPage = 1;
    },
    isActiveContract(val) {
      return moment(this.formatDate(val)).isAfter(moment());
    },
    clearFilters() {
      this.term = '';
      this.applyFilters();
    },
    opedAddPage() {
      miscService.goToPage('/admin/edi/add');
    },
    edit(edi) {
      localStorageService.set('edi-tracking-link', edi);
      miscService.goToPage(`/admin/edi/${edi.ediIds}/edit`);
    },
    resetFilter() {
      this.term = '';
      this.applyFilters();
    },
    pageChange(newPage) {
      let page = this.filteredEdiLinks.slice(
        (newPage - 1) * this.pageSize,
        newPage * this.pageSize
      );
      this.$store.commit('ediLinks/setPage', page);
    },
    confirmDelete(edi) {
      this.displayConfirmDelete = true;
      this.currentEdi = edi;
    },
  },
  computed: {
    ...mapGetters('ediLinks', ['all', 'page', 'filteredEdiLinks']),
    pagingLength() {
      return Math.ceil(this.filteredEdiLinks.length / this.pageSize);
    },
  },
});
